import { render, staticRenderFns } from "./LessonExamQuestion.vue?vue&type=template&id=148ddd0c&scoped=true"
import script from "./LessonExamQuestion.vue?vue&type=script&lang=js"
export * from "./LessonExamQuestion.vue?vue&type=script&lang=js"
import style0 from "./LessonExamQuestion.vue?vue&type=style&index=0&id=148ddd0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148ddd0c",
  null
  
)

export default component.exports